import { useQuery, type UseQueryResult } from '@tanstack/react-query'

import { type CustomKeySettingEntity } from '@/libs/api'

import { getCustomKeySettingsSelectQueryOptions } from '../query-options'

type Options = {
  enabled?: boolean
}

/**
 * 拠点のカスタムキー（5スロット固定）を取得する useQuery（#3463 VOC_PJ-829/851）。
 * 登録・編集フォームの表示可否 (`isVisible`) やラベル (`label`) の判定に使う共通フック。
 * 配送依頼登録/編集/矢羽根フォームとドロワー検索の双方から参照される想定のため、
 * dcId + tenantKey から5件を取得するだけの薄いラッパーとしている。
 */
export const useCustomKeySettingsQuery = (
  tenantKey: string,
  dcId: number | null | undefined,
  options?: Options
): UseQueryResult<CustomKeySettingEntity[]> => {
  const enabled = (options?.enabled ?? true) && dcId != null && dcId > 0
  return useQuery<CustomKeySettingEntity[]>({
    ...getCustomKeySettingsSelectQueryOptions({
      tenantKey,
      dcId: dcId ?? 0
    }),
    enabled,
    retry: false
  })
}
